import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    understand: 'I Understand',
    contactSupport: 'Message Customer Support',
  },
  de: {
    understand: 'Ich Verstehe',
    contactSupport: 'Kundensupport kontaktieren',
  },
});
